
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import {IApp} from "@/interfaces/app.interface";

  @Component({})
  export default class ReportThCell extends Vue {
    @Prop() cell: IReport.ITableProp;

    sortDirection = IApp.SortDirection;

    get sortingData() { return this.$store.state.report.sortingTable; }
    get disableSorting() { return this.cell.propType === IApp.SortingPropType.Actions || this.cell.noSorting; }

    setSorting() {
      if (this.disableSorting) return;

      this.$store.commit('report/setSorting', this.cell);
    }
  }
